import React from 'react';
import { Box, Table } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { currencyCommaConvert } from '@epi-helpers/numeral';
import { StatusDot } from '@epi-pages/Reports/TopupReports/TopupReports.styles';
import { reportStatusesColors } from '@epi-pages/Reports/utils';
import { DepositDetails } from '@epi-models/pages/Reports';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';

export const DepositsTableRow = ({
  id,
  amount,
  paymentMethodId,
  orderStatus,
  paymentDate,
  createdAt
}: DepositDetails) => {
  const { t } = useTranslation();

  return (
    <Table.Row>
      <Table.Cell>
        <Box display="flex" alignItems="center" lineHeight="25px">
          {apiToDefaultDateFormat(createdAt)}
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center" lineHeight="25px">
          {apiToDefaultDateFormat(paymentDate)}
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center">
          {id}
        </Box>
      </Table.Cell>
      <Table.Cell>
        {t(`containers.deposit_money.deposits_tab.methods.${paymentMethodId}`)}
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center">
          <StatusDot $dotColor={reportStatusesColors[orderStatus ?? '']} />
          {t(`containers.deposit_money.deposits_tab.statuses.${orderStatus}`)}
        </Box>
      </Table.Cell>
      <Table.Cell align="right">{currencyCommaConvert(amount)}</Table.Cell>
    </Table.Row>
  );
};
